import { ApiService } from '../models/Api.model';
import { AxiosInstance } from 'axios';
import IQueryTradesBasicInfo from '../interfaces/IQueryTradesBasicInfo';
import { generateQueryString } from 'src/util/helper';
import saveByteArray from 'src/util/saveByteArray';

enum ReportServiceEnum {
    exportTrades = "/export-trade?"
  }

export class ReportService extends ApiService {
    constructor(restClient: AxiosInstance) {
      super(restClient, "/report");
    }
  
    public exportTrades = async (queryString: IQueryTradesBasicInfo) => {
      const data = await this.GET(`${ReportServiceEnum.exportTrades}${generateQueryString(queryString)}`, "blob");
      saveByteArray("trades.xlsx", data);
      return data;
    };
}


// WEBPACK FOOTER //
// ./src/services/api/Report.service.ts